<ng-container *ngIf="showMobileHeader$ | async">
  <div class="gallery-destination">
    <div class="background" [class.animation]="headerAnimation"></div>
    @defer (when (isLoadingHome$ | async) === false) {
      <app-gallery-destination
        [isMobile]="isMobile$ | async"
        [images]="(homeData$ | async)?.banners"
        [height]="heightGallery"
        [source]="source"
        (trackEvent)="trackEvent($event)">
      </app-gallery-destination>
    }
  </div>
</ng-container>


<div class="homeCont" #homeContainer *ngIf="(isLoadingHome$ | async) === false; else placeholder">
  <ng-container *ngIf="isMobile$ | async">
    <div class="homeCont__searchText" *ngIf="routeSearch$ | async as route" [class.hidden]="headerAnimation" [routerLink]="route">
      <app-ds-input-search
        [isReadonly]="true"
        [placeholder]="'TITLE_SEARCH_HOME' | transloco">
      </app-ds-input-search>
    </div>

    <ng-container *ngFor="let group of countryModulesCollection$ | async; trackBy: itemTrackBy">
      <ng-container *ngIf="group.key">
        <div class="homeCont__chip-group-title">
          <app-ds-typography
            [fontFamily]="fontFamily.Regular"
            [size]="fontSize.Smaller"
            [color]="fontColor.Secondary"
            [text]="group.key | transloco | uppercase">
          </app-ds-typography>
        </div>
      </ng-container>
      <div class="homeCont__chips">
        <app-chip-cont [isSlider]="false">
          <ng-container *ngFor="let module of group?.value;">
            <div class="homeCont__chips__chip-action">
              <app-ds-chip-action
                [label]="module.title | transloco"
                [icon]="module.icon"
                [branding]="module.chipBranding"
                (clickEvent)="chipActionEvent(module)">
              </app-ds-chip-action>
            </div>
          </ng-container>
        </app-chip-cont>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="(isMobile$ | async) === false as isDesktopDevice">
    <div class="gallery-destination">
      <div class="background" [class.animation]="headerAnimation"></div>
        <app-gallery-destination
          [isMobile]="isMobile$ | async"
          [images]="(homeData$ | async)?.banners"
          [height]="heightGallery"
          [source]="source">
        </app-gallery-destination>
      </div>
    <div class="wrapper-search">
      <app-home-search-desktop></app-home-search-desktop>
    </div>

    <div class="alert-covid">
      <div class="alert-title">{{'COVID.INFORMATION'|transloco}}</div>
      <div class="alert-body">
        <p class="alert-text">
          {{'COVID.PROTOCOLOS'|transloco}}
        </p>
        <button class="alert-button">
          <i class="icon-arrow-forw"></i>
        </button>
      </div>
    </div>
  </ng-container>

  <div class="section-list">
    <app-home-section-list
      [isMobile]="isMobile$ | async"
      [source]="source"
      [homeSections]="(homeData$ | async)?.sections"
      [pageCode]="(homeData$ | async)?.code"
      (trackStoreSelected)="trackEvent($event)">
      <div class="widgets" homeWidgets="homeWidgets">
        <div class="abandoned-reservation">
          <app-abandoned-reservation></app-abandoned-reservation>
        </div>
        <app-recent-searches [index]="0"></app-recent-searches>
      </div>
    </app-home-section-list>
    <div [innerHTML]="footerDynamic|safeHtml"></div>
  </div>

  <div *ngIf="isMobile$ | async" class="content-text-legal">
    <ng-container *ngFor="let link of campaignsTerms">
      <ng-container *ngIf="link.available">
        <div class="terms-conditions">
          <a [routerLink]="[link.url]" [state]="link.state" skipLocationChange>
            {{ link.name | transloco }}
          </a>
        </div>
      </ng-container>
    </ng-container>
    <div class="terms-conditions">
      <ng-container *ngIf="!isPE">
        <a [routerLink]="['terms']" skipLocationChange>
          {{'FOOTER_MODULE.TITLES.TERMS_CONDITIONS' | transloco}}
        </a>
        <br>
        <hr>
      </ng-container>
      <a [routerLink]="['private-policy']" skipLocationChange>
        {{'FOOTER_MODULE.TITLES.PRIVACY_POLICY' | transloco}}
      </a>
    </div>
    <div class="terms-conditions" *ngIf="isPE">
      <a [routerLink]="['responsable-tourism']" skipLocationChange>
        {{'FOOTER_MODULE.TITLES.RESPONSABLE_TOURISM' | transloco}}
      </a>
      <br>
      <hr>
      <span class="aero-civil-section" (click)="goToLink(urlComplaintsResponsableTourismBook)">
        {{'FOOTER_MODULE.TITLES.COMPLAINTS_BOOK' | transloco}}
      </span>
    </div>
    <ng-container *ngIf="isPE">
      <ng-container *ngIf="!!urlFooterDocPDF">
        <div class="footer-home-pdf-doc">
          <img (click)="toogleFooterPDF()" loading="lazy" [src]="MINCETUR | baseImage : MINCETUR_PATH ">
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngTemplateOutlet="countryExtras"></ng-container>
    <ng-container>
      <div *ngIf="btnRepentance" class="btn-repentance" (click)="onBtnRepentance()">
        <button>{{'HOME_MODULE.CANCEL_PURCHASE'|transloco}}</button>
      </div>
    </ng-container>
    <div class="operated-by">
      <p #openOperatorCert [innerHTML]="operatedBy$ | async"></p>
    </div>
  </div>
</div>

<ng-template #placeholder>
  <app-home-placeholder [isMobile]="isMobile$ | async">
  </app-home-placeholder>
</ng-template>

<ng-template #countryExtras>
  <ng-container *ngIf="isCO">
    <div class="terms-conditions">
      <span class="sic-section" (click)="goToLink(getUrlSic)">
        {{ 'FOOTER_MODULE.NOTICES.SIC' | transloco }}
      </span>
    </div>
    <div class="terms-conditions">
      <span class="aero-civil-section" (click)="goToLink(getUrlAerocivil)">
        {{ 'FOOTER_MODULE.NOTICES.AEROCIVIL' | transloco }}
      </span>
    </div>
  </ng-container>
  <ng-container *ngIf="isAR">
    <div class="terms-conditions">
      <span class="aero-civil-section" (click)="goToLink(getUrlInquiriesAndComplains)">
        {{'FOOTER_MODULE.TITLES.INQUIRIES_COMPLAINTS' | transloco}}
      </span>
      <br>
      <hr>
      <a [routerLink]="['right-repentance']" skipLocationChange>
        {{'FOOTER_MODULE.TITLES.RIGHT_REPENTANCE' | transloco}}
      </a>
    </div>
  </ng-container>
</ng-template>

<ng-container *ngIf="isMobile$ | async">
  <ng-container *ngIf="urlFooterDocPDF">
    <app-swipe-up
      [height]="100"
      [showSwipeUp]="showFooterPDF"
      (toggleShowSwipeUp)="toogleFooterPDF()">
      <ng-container content>
        <div class="modal-pdf">
          <div class="button-close-modal">
            <i (click)="toogleFooterPDF()" class="icon-close"></i>
          </div>
          <div class="content-pdf" *ngIf="showFooterPDF">
            <app-pdf-viewer [srcPdf]="urlFooterDocPDF"></app-pdf-viewer>
          </div>
        </div>
      </ng-container>
    </app-swipe-up>
  </ng-container>
  <ng-container *ngIf="showOperatiorCert">
    <app-modal [classType]="'home-mobile-image-operated-by'" [zindex]="7" [width]="640" (toggleModal)="toggleOperatiorCert()">
      <ng-container content>
        <div class="cont-image-operated-by">
          <img class="op-cert-img" [src]="footerOperatedByImages | baseImage: 'web/travel/footer/operator-legal'">
        </div>
      </ng-container>
    </app-modal>
  </ng-container>
</ng-container>